import React from "react";
import dean from "../images/dean_25.jpg";
export default function About() {
  return (
    <div style={{ position: "absolute" }}>
      <div className="about-wrapper">
        <div className="left-content"></div>
        <div className="right-content">
          <p>
            Sapo’nuk Sustainability is an Indigenous-owned and managed
            consulting firm, launched in summer 2022. Our team has extensive
            experience in impact assessments, climate change, Indigenous rights,
            and sustainability in the energy, mining and infrastructure sectors.
            We also have established relationships with other environment and
            sustainability experts so that we can compile the right team to
            serve your needs.
          </p>
          <p>
            Sapo’nuk Sustainability works with First Nations, governments, and
            progressive companies and organizations to:
            <ul className="about-service-list ">
              <li>
                provide technical review and policy/process expertise in
                environmental impact assessments.
              </li>
              <li>
                support participation in the clean energy/Net Zero transition by
                developing decarbonization strategies, advising on smart climate
                policies, and providing technical expertise to participate in
                carbon markets and offset projects.
              </li>
              <li>develop sustainability strategies and reports.</li>
              <li>
                meaningfully integrate and prioritize Indigenous rights while
                addressing all these issues.
              </li>
            </ul>
          </p>
          <p>
            <img src={dean} className="profile-image" alt="Dean O'Gorman" />
            Our founder and principal consultant is Dean O’Gorman, who has
            almost 30 years of experience in the public and private sectors. He
            is a proud Mi'kmaq and Irish-Newfoundlander and a member of Qalipu
            First Nation, and is passionate about integrating environmental
            sustainability with Indigenous reconciliation and
            self-determination.
          </p>
          <p>
            Previously, Dean spent five years at the Alberta Energy Regulator,
            the independent regulator of Alberta’s energy sector, as a Hearing
            Commissioner deciding on controversial project applications,
            including serving on the federal-provincial Joint Review Panel that
            rejected the proposed Grassy Mountain coal project. He’s worked with
            the federal government at the Canadian Environmental Assessment
            Agency, as the Director overseeing the federal reviews of major
            projects across Canada, and spent over a decade in senior roles at
            Environment Canada helping shape Canada’s domestic climate change
            policy, including leading development of the federal GHG offset
            system and broader efforts to promote carbon markets. He also had an
            earlier stint in environmental consulting, and started working on
            climate change policy in the National Climate Change Process way
            back in 1997.{" "}
          </p>
        </div>
      </div>
    </div>
  );
}
